import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { DataSolicitudAyudantiasProy } from '../../interfaces/DataBsqProy';
import { Button, Card, CardContent, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { format } from 'date-fns';
import AyudantiaService from '../../services/AyudantiaService';
import { HiOutlineDocumentSearch } from 'react-icons/hi';
import { AyudantiaInvestigacion, VoidAyudantiaInvestigacion } from '../../interfaces/ayudantias/AyudantiaInvestigacion';
import { AyudanteInvInfo } from '../../interfaces/ayudantias/AyudanteInvInfo';
import { SmallModal } from '../Common/SmallModal';
import { FaRegEdit } from 'react-icons/fa';
import { MdDeleteForever } from 'react-icons/md';
import AlertService from '../../services/AlertService';
import AcademicoService from '../../services/AcademicoService';
import { EstudianteActivoDTO, VoidEstudianteActivoDTO } from '../../interfaces/SAAC/EstudianteActivoDTO';
import { CasUserContext } from '../../services/casUserContext';
import { SolicitudAyudantesInvForm } from '../ayudantias/SolicitudAyudantesInvForm';

const alertaService = new AlertService();
const academicoService = new AcademicoService();

interface Column {
  id: 'matricula' | 'nombre' | 'horas' | 'finan' | 'termino' | 'fecha' | 'estado' | 'opciones';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: 'matricula', label: 'Matrícula', minWidth: 100 },
  { id: 'nombre', label: 'Nombre', minWidth: 170 },
  { id: 'horas', label: 'Horas', minWidth: 50 },
  { id: 'finan', label: 'Financiamiento', minWidth: 170 },
  { id: 'termino', label: 'Término', minWidth: 50 },
  {
    id: 'fecha',
    label: 'Fecha',
    minWidth: 85,
  },
  {
    id: 'estado',
    label: 'Estado',
    minWidth: 100,
  },
  {
    id: 'opciones',
    label: 'Opciones',
    minWidth: 100,
  },
];

interface Data {
  name: string;
  code: string;
  population: number;
  size: number;
  density: number;
}

function createData(
  name: string,
  code: string,
  population: number,
  size: number,
): Data {
  const density = population / size;
  return { name, code, population, size, density };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    zIndex: 0,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    zIndex: -1,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const ayudantiaService = new AyudantiaService();

export default function BusqProyAyudantiasTable(props: DataSolicitudAyudantiasProy) {
  let history = useNavigate()
  const casUserContext = React.useContext(CasUserContext);
  const token = casUserContext.token;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(props.rowsPerPage[0]);
  const [isModalDetalle, setIsModalDetalle] = React.useState<boolean>(false);
  const [isModalEditar, setIsModalEditar] = React.useState<boolean>(false);
  const [isModalEliminar, setIsModalEliminar] = React.useState<boolean>(false);
  const [detalleData, setDetalleData] = React.useState<AyudantiaInvestigacion>(VoidAyudantiaInvestigacion());
  let [estudiante, setEstudiante] = React.useState<EstudianteActivoDTO>(VoidEstudianteActivoDTO());

  //#region Funciones 
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const goToNavigation = (site: string) => {
    history(site)
  }
  const EliminarAyudantia = (id: number) => {
    //console.log(id);
    setIsModalEliminar(false);
    alertaService.showLoading('Espere...')
    ayudantiaService.DeleteSolicitudAyudantiaInvById(id, token)
      .then((data) => {
        alertaService.hideLoading()
        if (data.status.isSuccessfully) {
          alertaService.alertaExito("Éxito", "Se elimino la solicitud");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          alertaService.alertaAdvertenciaList("Alerta", data.status.messages);
        }
      }).catch((error) => {
        console.error(error)
        alertaService.hideLoading()
        alertaService.alertaAdvertencia("Alerta", "No se completo el proceso")
      });
  }
  function estadoTexto(estado:string):string{
    let texto = '';
    switch(estado){
      case 'P':
        texto = 'Pendiente';
        break;
      case 'A':
        texto = 'Aprobado';
        break;
      case 'N':
        texto = 'Rechazado';
        break;
      case 'X':
        texto = 'Anulada';
        break;
      case 'R':
        texto = 'Reservado-Aprobado';
        break;
      case 'E':
        texto = 'Reservado-Rechazado';
        break;
      case 'G':
        texto = 'Negado-Aprobado';
        break;
      default:
         return '';
    }
    return texto;
  }
  const handleSearchDetalle = async (id: number) => {
    try {
      await ayudantiaService.GetSolicitudAyudantiaById(props.token, id)
        .then((data) => {
          //console.log(data.data);
          setDetalleData(data.data);
          consultarEstudiante(data.data.proyectoAyud.codEstudiante);
        })
        .catch((error) => {
          console.error(error)
        });
    } catch (error) {
      console.error('Error:', error);
    }
  };
  async function consultarEstudiante(codestudiante: string) {
    const resp = await academicoService.GetCarreraActivaByMatricula(token, codestudiante,'A');
    if (resp.status.isSuccessfully) {
        //console.log('Estudiante: ',resp.data);
        setEstudiante(resp.data);
    } else {
        console.error(resp.status.messages)
    }
}
  const handleOpenModal = async (data: AyudanteInvInfo) => {
    await handleSearchDetalle(data.idProyAyud);
    setTimeout(() => {
      setIsModalDetalle(true);
    }, 1000);
  };
  const handleCloseModal = () => {
    setIsModalDetalle(false);
  };
  const handleOpenModalEliminar = async (data: AyudanteInvInfo) => {
    await handleSearchDetalle(data.idProyAyud);
    setTimeout(() => {
      setIsModalEliminar(true);
    }, 1000);
  };
  const handleCloseModalEliminar = () => {
    setIsModalEliminar(false);
  };
  const handleOpenModalEditar = async (data: AyudanteInvInfo) => {
    await handleSearchDetalle(data.idProyAyud);
    setTimeout(() => {
      setIsModalEditar(true);
    }, 1000);
  };
  const handleCloseModalEditar = () => {
    setIsModalEditar(false);
  };
  function DentroPeriodoAyudantias(): boolean {
    let bandera = false;
    const today = new Date();
    if (props.fechasAyudantias.estado === 1) {
      const fechaInicio = new Date(props.fechasAyudantias.fechaAperturaAyud);
      const fechaFin = new Date(props.fechasAyudantias.fechaCierreAyud);
      bandera = today >= fechaInicio && today <= fechaFin;
    }
    return bandera;
  }
  function PeriodoActual(data: AyudanteInvInfo) {
    let bandera = data.termino+"-"+data.anio === props.periodoActivo.termino+"-"+props.periodoActivo.anio;
    return bandera;
  }  
  const handleResponseForm = async (responseData: AyudantiaInvestigacion) => {
    // Manejar la respuesta aquí
    console.log('aqui')
    setIsModalEditar(false);
    if (responseData.proyectoAyud.iddecinvproyectoayud > 0) {
      alertaService.alertaExito("éxito", "Se creado la nueva solicitud");
      const timer = setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };
  //#endregion
  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', minHeight: '50vh' }}>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <StyledTableCell
                  style={{ minWidth: column.minWidth }}
                  key={column.id}
                  align={column.align}>
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.length > 0 ? props.data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <StyledTableRow key={row.idProyAyud}>
                    <StyledTableCell component="th" scope="row">
                      {row.matricula}
                    </StyledTableCell>
                    <StyledTableCell align="left">{row.nombreEstudiante}</StyledTableCell>
                    <StyledTableCell align="left">{row.horas}</StyledTableCell>
                    <StyledTableCell align="left">{row.finanTexto}</StyledTableCell>
                    <StyledTableCell align="left">{row.termino+"-"+row.anio}</StyledTableCell>
                    <StyledTableCell align="left">{row.fechaSolicitud ? format(new Date(row.fechaSolicitud), 'dd/MMM/yyyy') : "Fecha no disponible"}</StyledTableCell>
                    <StyledTableCell align="left">{row.estadoTexto}</StyledTableCell>
                    <StyledTableCell align="left">
                      <Grid>
                        {PeriodoActual(row) && DentroPeriodoAyudantias() && row.estado !== 'I' ?
                          <Tooltip title={"Editar"} placement="top" arrow >
                            <IconButton aria-label="Editar" color="primary" onClick={() => {handleOpenModalEditar(row)}}>
                              <FaRegEdit />
                            </IconButton>
                          </Tooltip>
                          :
                          <Tooltip title={"Detalle"} placement="top" arrow >
                            <IconButton aria-label="Detalle" color="primary" onClick={() => { handleOpenModal(row) }}>
                              <HiOutlineDocumentSearch />
                            </IconButton>
                          </Tooltip>
                        }
                        {PeriodoActual(row) && DentroPeriodoAyudantias() && row.estado !== 'I' ?
                          <Tooltip title={"Eliminar"} placement="top" arrow >
                            <IconButton aria-label="Eliminar" color="error" onClick={() => {handleOpenModalEliminar(row)}}>
                              <MdDeleteForever />
                            </IconButton>
                          </Tooltip>
                          : <></>
                        }
                      </Grid>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              }) :
              <StyledTableRow key={0}>
                <StyledTableCell component="th" scope="row"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left">{'Sin resultados'}</StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
              </StyledTableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={props.rowsPerPage}
        component="div"
        count={props.data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <SmallModal
        title='Detalle Solicitud'
        open={isModalDetalle}
        onClose={handleCloseModal}
        content={<>
        <Card sx={{ margin: 2 }}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                {detalleData.tituloProyecto}
              </Typography>
              {/* Sección de Itinerario */}
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Datos de la Solicitud
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Typography variant="body1"><strong>Estudiante:</strong> {detalleData.estudiante}</Typography>
                  <Typography variant="body1"><strong>Descripción:</strong> {detalleData.proyectoAyud.descripcion}</Typography>
                  <Typography variant="body1"><strong>Termino:</strong> {detalleData.proyectoAyud.termino+"-"+detalleData.proyectoAyud.anio}</Typography>
                  <Typography variant="body1"><strong>Número de Horas:</strong> {detalleData.detalle.numhoras+" horas"}</Typography>
                </Grid>
                {detalleData.gestion.find(x => x.tipopersona === 'S') !== null ?
                <Grid item xs={12} sm={12}>
                  <Typography variant="body1"><strong>Estado Decanato de Investigación:</strong></Typography>
                  <Typography variant="body1">{estadoTexto(detalleData.gestion.find(x => x.tipopersona === 'S')?.estado??'')}</Typography>
                  <Typography variant="body1"><strong>Comentario:</strong> {detalleData.proyectoAyud.comentario}</Typography>
                </Grid> 
                :<></>  
                }
                {detalleData.gestion.find(x => x.tipopersona === 'V') !== null ?
                <Grid item xs={12} sm={12}>
                  <Typography variant="body1"><strong>Respuesta Vicerrectorado:</strong></Typography>
                  <Typography variant="body1">{detalleData.gestion.find(x => x.tipopersona === 'V')?.observacion}</Typography>
                  <Typography variant="body1"><strong>Estado:</strong>{estadoTexto(detalleData.gestion.find(x => x.tipopersona === 'V')?.estado??'')}</Typography>
                </Grid> 
                :<></>  
                }
              </Grid>
            </CardContent>
          </Card>
                 </>}
      />
      <SmallModal
        title='Eliminar Solicitud'
        open={isModalEliminar}
        onClose={handleCloseModalEliminar}
        content={<>
        <Card sx={{ margin: 2 }}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                {detalleData.tituloProyecto}
              </Typography>
              {/* Sección de Itinerario */}
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Datos de la Solicitud
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Typography variant="body1"><strong>Estudiante:</strong> {detalleData.estudiante}</Typography>
                  <Typography variant="body1"><strong>Descripción:</strong> {detalleData.proyectoAyud.descripcion}</Typography>
                  <Typography variant="body1"><strong>Termino:</strong> {detalleData.proyectoAyud.termino+"-"+detalleData.proyectoAyud.anio}</Typography>
                  <Typography variant="body1"><strong>Número de Horas:</strong> {detalleData.detalle.numhoras+" horas"}</Typography>
                </Grid>
                <Grid item xs={12}
                  sm={12}
                  container // Añadir esto para activar el comportamiento de flexbox en el Grid
                  direction="row"
                  justifyContent="flex-end" // Cambiado a 'flex-end' para alinear a la derecha
                  alignItems="center"
                >
                  <Button variant="contained" style={{ backgroundColor: 'red', color: 'white' }} onClick={() => { EliminarAyudantia(detalleData.proyectoAyud.iddecinvproyectoayud) }}>
                    Eliminar
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
                 </>}
      />
      <SmallModal
        title='Editar Solicitud'
        open={isModalEditar}
        onClose={handleCloseModalEditar}
        content={<>
        <Card sx={{ margin: 2 }}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                {detalleData.tituloProyecto}
              </Typography>
              {/* Sección de Itinerario */}
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Datos de la Solicitud
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Typography variant="body1"><strong>Estudiante:</strong> {detalleData.estudiante}</Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                <SolicitudAyudantesInvForm token={token} estudiante={estudiante} idProyecto={detalleData.proyectoAyud.iddecinvproyecto} onResponse={handleResponseForm} ayudantia={detalleData} />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
                 </>}
      />
    </Paper>
  );
}